module.exports = __webpack_public_path__ + "img/cp-pg.26429df5.jpg";